import { Component, Vue } from 'vue-property-decorator';
// import { useStore } from 'vuex-simple';
// import { RooStore } from '@/store/store';

export { Component, Watch, Prop } from 'vue-property-decorator';
export { default as Throttle } from '../decorators/throttle';

@Component({})
export default class BaseComponent extends Vue {
   // public store: RooStore = useStore(this.$store);

   // protected $processError(e: any) {
   //    const code = ((e || {}).response || {}).status;
   //    if (code === 401) {
   //       window.location.replace('../logout.aspx');
   //    } else if (code === 404) {
   //       this.$router.push({ name: '404' });
   //    } else if (code === 500) {
   //       this.$router.push({ name: '500' });
   //    }
   //    console.error(e);
   // }
}
